/**
 * Ce qu'une variable du CRM contient, déduit de sa seule clé.
 *
 * Le catalogue ne type pas ses variables, et un modèle les reçoit sans valeur :
 * la clé est le seul indice disponible partout. Règle commune à l'éditeur
 * classique (`ImageCascader`) et au site (champ image).
 */

const IMAGE_KEY_PARTS = [
  'LOGO',
  'PHOTO',
  'PICTURE',
  'CHART',
  'OFFICE_PICTURE',
  'ORGANIZATIONAL_CHART',
  'QUALITY_TAGS',
  'TEAM_PICTURE',
  'REFERENCIES_PICTURE',
];

export const variableIsAnImage = (item) => {
  // Sécurise l'accès à `indexOf` si `item` est null/undefined ou non chaîne/tableau
  if (!item || typeof item.indexOf !== 'function') {
    return false;
  }

  return IMAGE_KEY_PARTS.some((part) => item.indexOf(part) > -1);
};

// Une variable adresse (entity.ADDRESS, billed_customer.ADDRESS1,
// opportunity.*_CONTACT_ADDRESS…) vaut plusieurs lignes. En modèle sa valeur
// est vide, on ne peut donc pas la mesurer : la clé est le seul indice
// disponible pour proposer quand même le choix du nombre de lignes.
export const variableIsAnAddress = (item) => {
  if (!item || typeof item.indexOf !== 'function') {
    return false;
  }

  return item.indexOf('ADDRESS') > -1;
};

// Variable dont l'occurrence accepte un nombre de lignes au choix (cf.
// VariableLineStyleControl) : une adresse, ou toute valeur déjà multi-lignes.
// En modèle la valeur est vide, la clé est alors le seul indice ; en
// proposition la valeur est renseignée et le test sur '\n' couvre les autres.
export const variableSupportsLineStyle = (variableKey, value) =>
  (typeof value === 'string' && value.includes('\n')) || variableIsAnAddress(variableKey);
